import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {TimelineLite, TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";


export class MaxCapOutroView extends ScreenView {

    private _splash: PIXI.Sprite;
    private _totalWinCountUp: PIXI.BitmapText;
    private _shootContainer:PIXI.Container;

    private winCapStr: string = "Wincap";
    private posterContainer: PIXI.Container;
    private _rays:TimelineSprite;


    private winCapSprite: PIXI.Sprite;
    private posterSprites: PIXI.Sprite [] = [];

    private winCapSpine: PIXI.spine.Spine;

    constructor(config:IScreenViewConfig, autoClose?:boolean) {
        super(config, autoClose);
    }

    createPoster():void {
        this.posterContainer = new PIXI.Container();

        this.winCapSprite = new PIXI.Sprite();//new PIXI.Sprite(GameResources.getTextures(this.winCapStr)[0]);
        this.winCapSprite.anchor.set(0.5, 0.5);
        this.winCapSprite.y = 20;
        //this.winCapSprite.scale.set(0.5, 0.5);
        this.winCapSprite.alpha = 0;

        /*this.winCapSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("capWin")); // Ask Ed to export below <3.8.x
        const animation:any = this.winCapSpine.skeleton.data.animations;
        console.log("SPINE ANIMS", animation);
        this.winCapSpine.state.setAnimation(0, animation[1].name, true);
        //this.winCapSpine.scale.set(1.45, 1.45);
        this.winCapSpine.scale.set(0.75, 0.75);
        this.winCapSprite.addChild(this.winCapSpine);*/
        //this.addChild(this.winCapSpine);

        this.posterContainer.addChild(this.winCapSprite);



        this.posterSprites.push(this.winCapSprite);

        this._rays = new TimelineSprite(GameResources.getTextures("bigWinRays"));
        this._rays.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._rays.anchor.set(0.5, 0.5);
        this._rays.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.3);
        this._rays.scale.set(2.5, 2.5);
        this.addChild(this._rays);

        this.addChild(this.posterContainer);

        this._shootContainer = new PIXI.Container();

        this.posterContainer.addChild(this._shootContainer);
    }

    protected createGameGraphics():PIXI.DisplayObject {

        this._splash = new PIXI.Sprite(); //new PIXI.Sprite(GameResources.getTextures("fs/outro/MaxCap_720")[0]); TODO: new image!
        this._splash.anchor.set(0.5);
        this._splash.position.set(560, 360);
        this._splash.alpha = 0;
        this.addChild(this._splash);

        this.createPoster();

        return new PIXI.Container();
    }
    protected setButtonPosition(data:IResizeData):void {
        this._button.position.set(625, NolimitApplication.screenBounds.bottom - this._button.height * 0.5 - 50);
    }

    protected onResize(resizeData:IResizeData):void {
        if(!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }

        this._screenWidth = resizeData.width / this._layer.scale.x;
        this._screenHeight = resizeData.height / this._layer.scale.y;
        this._orientationScale = resizeData.orientation === Orientation.PORTRAIT ? (this._config.portraitScale ? this._config.portraitScale : this.DEFAULT_PORTRAIT_SCALE) : 1;

        if(this.onResizeBackground) {
            this.onResizeBackground(resizeData);
        }

        this.onResizeButton(resizeData);

        if(this.onResizeGameGraphics) {
            this.onResizeGameGraphics(resizeData);
        }

        this._isResizeDirty = false;

        this.posterSprites[0].y = 50;
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            (<PIXI.Sprite>this._background).width = 1280;
            (<PIXI.Sprite>this._background).height = 720;
            this._background.position.set(0, 0);

            // Posters
            this.posterSprites[0].position.set(640, 360);
        }
        else {
            (<PIXI.Sprite>this._background).width = 1280;
            (<PIXI.Sprite>this._background).height = 2080;
            this._background.position.set(0, -550);

            // Posters
            this.posterSprites[0].position.set(640, 360);
        }
    }

    private readonly _f:number = 0.8;
    private readonly _holePositions:[number, number][][] = [
        [
            [520, 480 + 40], [490, 460 + 40], [570, 500 + 40],
            [515, 470 + 40], [525, 460 + 40], [530, 455 + 40]
        ]
    ];

    private getLevelShootAnimation():TimelineLite {
        const timeline:TimelineLite = new TimelineLite();

        // the animation is already work well, so I will not change it to the ShootingAnimation unless we do some change later.
        this._holePositions[0].forEach((position:[number, number], index:number) => {
            const hole:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("bulletHole")[0]);
            hole.anchor.set(0.5, 0.5);
            hole.position.set(position[0], position[1]);
            hole.visible = false;
            const smoke:TimelineSprite = new TimelineSprite(GameResources.getTextures("holeSmoke"));
            smoke.blendMode = PIXI.BLEND_MODES.SCREEN;
            smoke.anchor.set(0.5, 1);
            smoke.scale.set(2, 2);
            smoke.position.set(position[0], position[1] + Math.round(hole.height / 2));
            smoke.hide();
            const spark:TimelineSprite = new TimelineSprite(GameResources.getTextures("sparkSmoke"));
            spark.blendMode = PIXI.BLEND_MODES.SCREEN;
            spark.anchor.set(0.5, 0.5);
            spark.position.set(position[0], position[1]);
            spark.hide();

            const shootTimeline:TimelineLite = new TimelineLite();
            shootTimeline.add([
                () => {
                    this._shootContainer.alpha = 1;
                    this._shootContainer.addChild(hole);
                    this._shootContainer.addChild(smoke);
                    this._shootContainer.addChild(spark);
                    SlotGame.sound.playEffect(TombstoneSoundConfig.getPistolSoundName());
                },
                spark.getAnimationAutoShowHide(),
                smoke.getAnimationAutoShowHide()
            ]);
            shootTimeline.add(() => hole.visible = true, 0.05);

            timeline.add(shootTimeline, 0.5 + 0.1 * index);
        });

        return timeline;
    }

    private clearAllShoots():void {
        if(this._shootContainer.children.length > 0) {
            this._shootContainer.removeChildren();
        }
    }

    private readonly DEFAULT_BUTTON_SIZE_OVR:PIXI.Point = new PIXI.Point(240, 64);

    getScaledButtonSizeOverride():PIXI.Point {
        const buttonSize:PIXI.Point = this._config.buttonSize ? this._config.buttonSize : this.DEFAULT_BUTTON_SIZE_OVR;
        return new PIXI.Point(buttonSize.x * this._deviceScale, buttonSize.y * this._deviceScale);
    }

    protected onResizeButton(data:IResizeData):void {
        const buttonSize:PIXI.Point = this.getScaledButtonSizeOverride();
        this._button.setSize(buttonSize.x, buttonSize.y, this._layer.scale.x * this._orientationScale);
        this._button.scale.set(this._orientationScale, this._orientationScale);

        this.setButtonPosition(data);
    }


    protected createBackground():PIXI.DisplayObject {
        const bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        bg.tint = 0x120202;
        bg.alpha = 0;
        return bg;
    }

    protected onResizeBackground(data:IResizeData):void {
        (<PIXI.Sprite>this._background).width = NolimitApplication.screenBounds.width;
        (<PIXI.Sprite>this._background).height = NolimitApplication.screenBounds.height;
        this._background.position.set(0, NolimitApplication.screenBounds.top);
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {

        if(!this._totalWinCountUp) {
            this._totalWinCountUp = new PIXI.BitmapText("16480x", {
                fontName: "Multipliers",
                fontSize: 20,
                tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
            });
            this._totalWinCountUp.position.set(440, 360);
            this._totalWinCountUp.alpha = 0;
            this._splash.position.set(560, 360);
            this.addChild(this._totalWinCountUp);
        }

        this._splash.alpha = 0;
        this._button.alpha = 0;
        this._totalWinCountUp.alpha = 0;

        this.winCapSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("capWin")); // Ask Ed to export below <3.8.x
        const animation:any = this.winCapSpine.skeleton.data.animations;
        //console.log("SPINE ANIMS", animation);
        this.winCapSpine.state.setAnimation(0, animation[1].name, true);
        this.winCapSpine.scale.set(0.75, 0.75);
        this.winCapSprite.addChild(this.winCapSpine);


        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            TombstoneGameModuleConfig.TBBWController.rescaleAndPosForWinCap(),
            TweenLite.fromTo(this._background, 0.5, {alpha : 0}, {alpha : 0.8}),
            TweenLite.to(this._splash, 0.3, {alpha : 1, delay : 0.1}),
            () => {
                TombstoneGameModuleConfig.TBBWController.playEndForWinCap();
            }
        ]);

        timeline.add(this.getLevelShootAnimation());

        timeline.add([
            () => {
                this._rays.playLoop();
                this.winCapSprite.alpha = 1;
                this.winCapSpine.state.setAnimation(0, "capwin_intro", false);
            },
            //TweenLite.fromTo(this.winCapSprite.scale, 0.3, {x: 0.2, y: 0.2}, {x: 0.5, y: 0.5}),
            //TweenLite.to(this.winCapSprite, 0.3, {alpha : 1}),
            TweenLite.to(this._rays, 0.2, {alpha : 1, delay : 0.1}),
        ], 0);

        timeline.add(() => {
            this.winCapSpine.state.setAnimation(0, "capwin_loop", true);
        }, 2);

        timeline.add([
            TweenLite.to(this._button, 0.22, {alpha : 1}),
        ], timeline.totalDuration() - 0.1);
        timeline.add(TombstoneGameModuleConfig.TBBWController.fadeOutForWinCap());
        timeline.add(TweenLite.fromTo(this._totalWinCountUp, 0.2, {alpha: 0}, {alpha: 1}));
        timeline.add(() => super.startPresentation(data, onShowComplete));
    }

    protected onButtonClick() {
        SlotGame.sound.stopEffect(TombstoneSoundConfig.instance.CAP_WIN_LOOP, 100);
        SlotGame.sound.playEffect(TombstoneSoundConfig.instance.CAP_WIN_ENDS);

        super.onButtonClick();

        SlotGame.sound.playAmbience(TombstoneSoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.fadeAmbience(1, 100);
    }


    protected stopPresentation(closeCallback?:() => void):void {

        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => this._button.enabled = false,
            TweenLite.to(this._button, 0.2, {alpha : 0})
        ]);
        timeline.add([
            //TweenLite.to(this._winCapText, 1, {alpha : 0}),
            TweenLite.to(this._totalWinCountUp, 1, {alpha : 0}),
            TweenLite.to(this._splash, 0.6, {alpha : 0}),
            TweenLite.to(this._background, 1.5, {alpha : 0}),
        ], 1);
        timeline.add(() => {
            this._rays.stopLoop();
            super.stopPresentation(closeCallback);
            this.clearAllShoots();
            TombstoneGameModuleConfig.TBBWController.hideCountUp();
            this.winCapSprite.alpha = 0;
            this._totalWinCountUp.alpha = 0;
            this.winCapSpine.state.setEmptyAnimation(0, 0);
        });
    }

}